import {
  type ConfirmModalProps,
  notify,
  useConfirmModal,
} from '@affine/component';
import { AuthService } from '@affine/core/modules/cloud';
// import { RESPONSE_CODE } from '@affine/core/modules/cloud/server/config';
// import {
//   clearLoginCookieInfo,
//   getLoginTokenCookie,
//   getVisitorIdByCookie,
// } from '@affine/core/modules/cloud/server/utils';
import { UserFriendlyError } from '@affine/error';
// import { ServerFeature } from '@affine/graphql';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { useNavigateHelper } from '../use-navigate-helper';

type SignOutConfirmModalI18NKeys =
  | 'title'
  | 'description'
  | 'cancel'
  | 'confirm';

export const useSignOut = ({
  onConfirm,
  confirmButtonOptions,
  contentOptions,
  ...props
}: ConfirmModalProps = {}) => {
  const t = useI18n();
  const { openConfirmModal } = useConfirmModal();
  const { jumpToSignIn } = useNavigateHelper();

  const authService = useService(AuthService);
  // const { defaultServerService } = useServices({ DefaultServerService });
  const account = useLiveData(authService.session.account$);
  const signOut = useCallback(async () => {
    onConfirm?.()?.catch(console.error);
    // const enableLocalWorkspace =
    //   BUILD_CONFIG.isNative ||
    //   defaultServerService.server.config$.value.features.includes(
    //     ServerFeature.LocalWorkspace
    //   );

    try {
      const signOutSuccess = await authService.signOut(
        account?.id,
        account?.info?.token
      );
      // if (enableLocalWorkspace) {
      //   jumpToIndex();
      // } else {
      if (signOutSuccess) {
        jumpToSignIn();
      }

      // }
    } catch (err) {
      console.error(err);
      const error = UserFriendlyError.fromAny(err);
      notify.error(error);
    }
  }, [
    authService,
    account?.id,
    account?.info?.token,
    // jumpToIndex,
    jumpToSignIn,
    // defaultServerService,
    onConfirm,
  ]);

  const getDefaultText = useCallback(
    (key: SignOutConfirmModalI18NKeys) => {
      return t[`com.affine.auth.sign-out.confirm-modal.${key}`]();
    },
    [t]
  );

  const confirmSignOut = useCallback(() => {
    openConfirmModal({
      title: getDefaultText('title'),
      description: getDefaultText('description'),
      cancelText: getDefaultText('cancel'),
      confirmText: getDefaultText('confirm'),
      confirmButtonOptions: {
        ...confirmButtonOptions,
        variant: 'error',
        ['data-testid' as string]: 'confirm-sign-out-button',
      },
      contentOptions: {
        ...contentOptions,
        ['data-testid' as string]: 'confirm-sign-out-modal',
      },
      onConfirm: signOut,
      ...props,
    });
  }, [
    confirmButtonOptions,
    contentOptions,
    getDefaultText,
    openConfirmModal,
    props,
    signOut,
  ]);

  return confirmSignOut;
};
